import { mapStyles } from './mapStyles';

export const API_KEY = 'AIzaSyAyzVc46RCgxcT3nEFdrDhJ-AiN94DKzqc';
export const MAP_ID = 'google-map-script';

export const BLUE = '#0460CC';
export const BLUE_OPACITY = '.3';

export const GREEN = '#00BC80';
export const GREEN_OPACITY = '.4';

export const ORANGE = '#FF8400';
export const ORANGE_DARK = '#B25C00';
export const ORANGE_OPACITY = '.5';

export const ZOOM = {
  DESKTOP: 10.4,
  MOBILE: {
    DEFAULT: 9,
    FULL_SCREEN: 9.4,
  },
  TABLET: {
    DEFAULT: 10,
    FULL_SCREEN: 10,
  },
};

export const CENTER = {
  DESKTOP: {
    lat: 51.51,
    lng: -0.12,
  },
  MOBILE: {
    DEFAULT: {
      lat: 51.24,
      lng: -0.12,
    },
    FULL_SCREEN: {
      lat: 51.37,
      lng: -0.11,
    },
  },
  TABLET: {
    DEFAULT: {
      lat: 51.475,
      lng: -0.145,
    },
    FULL_SCREEN: {
      lat: 51.5,
      lng: -0.115,
    },
  },
};

export const MAP_OPTIONS = {
  controlSize: 36,
  disableDefaultUI: true,
  mapTypeControl: false,
  restriction: {
    strictBounds: false,
  },
  styles: mapStyles,
};

export const MAP_CONTROLS = {
  disableDoubleClickZoom: true,
  draggable: false,
  scrollwheel: false,
};

export const EXPANDED_MAP_CONTROLS = {
  disableDoubleClickZoom: false,
  draggable: true,
  gestureHandling: 'greedy',
  scrollwheel: true,
};

export const CLOSE_EXPANDED_MAP_VIEW_ANIMATION_LENGTH = 250;
